import { CreateAutomationTaskInput } from 'services/automation/types';
import { findDuplicatedAutomationTasks } from 'services/automation/utils/findDuplicatedAutomationTasks';
import { FormValues } from '../types';
import {
  getValidAutomationItems,
  validateAutomationItems
} from './validateAutomationItems';

type ValidationResult = {
  isValid: boolean;
  tasks: CreateAutomationTaskInput[];
  error?: string;
};

export const validateAndGetAutomationTasks = (
  values: FormValues
): ValidationResult => {
  const isValid = validateAutomationItems(values);
  if (!isValid) {
    return {
      isValid: false,
      tasks: [],
      error: 'Please fix automation errors before launching.'
    };
  }

  const validAutomationTasks = getValidAutomationItems(values);
  const duplicates = findDuplicatedAutomationTasks(validAutomationTasks);

  if (duplicates.length) {
    return {
      isValid: false,
      tasks: [],
      error:
        'You have conflicting automations. Please remove them before saving.'
    };
  }

  return { isValid: true, tasks: validAutomationTasks };
};
